import { useState } from 'react';
import { Play } from 'lucide-react';

interface VideoPlayerProps {
  videoId: string;
  thumbnail: string;
  title: string;
}

export function VideoPlayer({ videoId, thumbnail, title }: VideoPlayerProps) {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className="relative rounded-lg overflow-hidden bg-black">
      {!isPlaying ? (
        <div 
          className="relative aspect-video cursor-pointer group" 
          onClick={() => setIsPlaying(true)}
        >
          <img 
            src={thumbnail} 
            alt={title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex items-center justify-center 
                        bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity">
            <Play className="w-16 h-16 text-white" />
          </div>
        </div>
      ) : (
        <div className="aspect-video">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title={title}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}
    </div>
  );
} 